import { useCallback, useEffect, useState } from 'react'

const KEY = 'esmax-portal:theme'

/**
 * Tema del portal, elegible por el usuario final.
 *
 * Sin elección explícita manda `prefers-color-scheme`, que el CSS ya está
 * pintando: el estado inicial se toma de ahí para que el control nazca
 * sincronizado y no haya destello. Al elegir se estampa `data-theme`, que
 * gana en los dos sentidos.
 */
export function useTheme(): { dark: boolean; toggle: () => void } {
  const [dark, setDark] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    let saved: string | null = null
    try {
      saved = window.localStorage.getItem(KEY)
    } catch {
      /* modo privado */
    }
    if (saved === 'dark') return true
    if (saved === 'light') return false
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
  }, [dark])

  const toggle = useCallback(() => {
    setDark((prev) => {
      const next = !prev
      try {
        window.localStorage.setItem(KEY, next ? 'dark' : 'light')
      } catch {
        /* modo privado: la preferencia dura lo que la pestaña */
      }
      return next
    })
  }, [])

  return { dark, toggle }
}
